import React from "react";

const Error = ({ text }) => {
	return <p className="error">{text}</p>;
};

export default Error;
